export default "__VITE_ASSET__BCSd87_o__"